import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchProjects: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'project/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_PROJECT_REQUEST,
                        types.SEARCH_PROJECT_SUCCESS,
                        types.SEARCH_PROJECT_FAILURE
                    ]
                }
            });
        },
    loadProjectListFilters: (subscriptionId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'project/list-filters',
                    method: 'POST',
                    body: { subscriptionId: subscriptionId },
                    types: [
                        types.LOAD_PROJECT_FILTERS_REQUEST,
                        types.LOAD_PROJECT_FILTERS_SUCCESS,
                        types.LOAD_PROJECT_FILTERS_FAILURE
                    ]
                }
            });
        },
    listProjectBaselines: (projectId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'project/list-project-baselines',
                    method: 'POST',
                    body: { projectId : projectId },
                    types: [
                        types.LIST_PROJECT_BASELINES_REQUEST,
                        types.LIST_PROJECT_BASELINES_SUCCESS,
                        types.LIST_PROJECT_BASELINES_FAILURE
                    ]
                }
            });
        },
    saveProject: (project) =>
        (dispatch) => {
            if (project.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'project/create',
                        method: 'POST',
                        body: project,
                        types: [
                            types.CREATE_PROJECT_REQUEST,
                            types.CREATE_PROJECT_SUCCESS,
                            types.CREATE_PROJECT_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'project/update',
                        method: 'PUT',
                        body: project,
                        types: [
                            types.UPDATE_PROJECT_REQUEST,
                            types.UPDATE_PROJECT_SUCCESS,
                            types.UPDATE_PROJECT_FAILURE
                        ]
                    }
                });
            }
        },
    copyProject: (project) =>
    (dispatch) => {
        return dispatch({
            [CALL_API]: {
                endpoint: 'project/copy',
                method: 'POST',
                body: project,
                types: [
                    types.COPY_PROJECT_REQUEST,
                    types.COPY_PROJECT_SUCCESS,
                    types.COPY_PROJECT_FAILURE
                ]
            }
        });
    },    
    searchByLocation: (locationId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'project/search-by-location',
                    method: 'POST',
                    body: { locationId: locationId },
                    types: [
                        types.LOAD_PROJECT_LIST_REQUEST,
                        types.LOAD_PROJECT_LIST_SUCCESS,
                        types.LOAD_PROJECT_LIST_FAILURE
                    ]
                }
            });
        },
    setProjectManagerFilter: (projectManagers) => {
            return (dispatch) => {
                return dispatch({
                    type: types.SET_PROJECTMANAGER_FILTER,
                    payload: {
                        projectManagers: projectManagers
                    }
                });
            }
        },
    updateProjectName: (projectId, projectName) =>
    (dispatch) => {
        return dispatch({
            [CALL_API]: {
                endpoint: 'project/update-name',
                method: 'POST',
                body: { 
                    projectId: projectId,
                    name: projectName
                },
                types: [
                    types.UPDATE_PROJECT_NAME_REQUEST,
                    types.UPDATE_PROJECT_NAME_SUCCESS,
                    types.UPDATE_PROJECT_NAME_FAILURE
                ]
            }
        });
    },    
    updateProjectStatus: (projectId, isActive) =>
    (dispatch) => {
        return dispatch({
            [CALL_API]: {
                endpoint: 'project/update-status',
                method: 'POST',
                body: { 
                    projectId: projectId,
                    isActive: isActive
                },
                types: [
                    types.UPDATE_PROJECT_STATUS_REQUEST,
                    types.UPDATE_PROJECT_STATUS_SUCCESS,
                    types.UPDATE_PROJECT_STATUS_FAILURE
                ]
            }
        });
    },
    getProject: (projectKey) =>
    (dispatch) => {
        return dispatch({
            [CALL_API]: {
                endpoint: `project/${projectKey}`,
                method: 'GET',
                types: [
                    types.GET_PROJECT_REQUEST,
                    types.GET_PROJECT_SUCCESS,
                    types.GET_PROJECT_FAILURE
                ]
            }
        });
    },
    saveUserFavoriteProject: (favoriteProjects, currentUserFavoriteProjects) =>     
        (dispatch) => {
            if(favoriteProjects.lengt === 0){
                console.log('0 projects sent');
                return;
            } 

            return dispatch({
                [CALL_API]: {
                    endpoint: `project/save-user-favorite`,
                    body: { favoriteProjects, currentUserFavoriteProjects },
                    method: 'POST',
                    types: [
                        types.POST_SAVE_FAVORITE_PROJECT_REQUEST,
                        types.POST_SAVE_FAVORITE_PROJECT_SUCCESS,
                        types.POST_SAVE_FAVORITE_PROJECT_FAILURE
                    ]
                }
            });
        }      
}
